export default __webpack_public_path__ + "static/media/anuj.15bd41fa.jpeg";